import axios, { AxiosResponse } from "axios";
import { SavePlannerResponse } from "../features/planner/api/SavePlannerResponse";

export async function cancelPlannerPost(
  accountId: string,
  post: {
    _id: string;
    originalPostType: string;
  }
): Promise<AxiosResponse<SavePlannerResponse>> {
  return await axios.post(`/planner/${accountId}`, {
    reorderedPosts: [],
    cancelledPosts: [post],
  });
}
